import { React } from "react";

const TableTab = (props) => {
  return (
    <div className="mt-6">
      <div className="flex justify-center gap-[50px]  text-md">
        {props.data.map((tab, idx) => {
          return (
            <button
              key={idx}
              className={`border-b-2 px-2 text-md transition-colors duration-300 ${
                idx === props.activeTab
                  ? "bg-[#0F3A62] text-white px-5 py-1"
                  : "border-none text-black"
              }`}
              onClick={() => props.handlechange(idx)}
            >
              {tab.label}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default TableTab;
